import '@formkit/themes/genesis';
import '@formkit/pro/genesis';

import { createMultiStepPlugin } from '@formkit/addons';
import { en, nl } from '@formkit/i18n';
import { createProPlugin, inputs } from '@formkit/pro';
import { defaultConfig } from '@formkit/vue';

import {
  checkIban,
  checkReportCode,
  initialsCorrect,
  isEmailCorrect,
  regexHouseNumber,
  regexPostalCode,
} from '@/config/config.formkitValidationRules.js';
import * as ValidationMessagesEn from '@/locales/validation/validation.en.json';
import * as ValidationMessagesNl from '@/locales/validation/validation.nl.json';

const proPlugin = createProPlugin('fk-4919a92477a', inputs);

const FormKitOptions = defaultConfig({
  plugins: [proPlugin, createMultiStepPlugin()],
  locales: { nl, en },
  locale: import.meta.env.VITE_I18N_LOCALE || 'nl',
  rules: {
    checkReportCode,
    regexPostalCode,
    regexHouseNumber,
    initialsCorrect,
    isEmailCorrect,
    checkIban,
  },
  messages: {
    nl: {
      validation: {
        ...JSON.parse(JSON.stringify(ValidationMessagesNl.validation)),
        required({ name }) {
          return `Antwoord ontbreekt bij ${name}.`;
        },
      },
    },
    en: {
      validation: {
        ...JSON.parse(JSON.stringify(ValidationMessagesEn.validation)),
        required({ name }) {
          return `Answer is missing for ${name}.`;
        },
      },
    }
  },
});
export default FormKitOptions;
